import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import EmployeeStage from "../../components/anlage/new_anlage/EmployeeStage";
import { IoIosContact } from "react-icons/io";
import { useAuthState } from "../../context/AuthContext";

const ContactPersonModal = ({ show, setShow }) => {

    const [stage, setStage] = useState("contact");
    const {contactPerson} = useAuthState();

    useEffect(() => {
        if (show) {
            setStage("contact");
        }
    }, [show])

    return (
        <Modal size="xl" show={show}>
            <Modal.Body>
                {stage === "contact" ?
                    <EmployeeStage setStage={setStage} setShow={setShow} /> :

                    stage === "default" ?
                        <Row>
                            <Col xl="12" className="text-center">
                                <p className="text-energo mb-5">Ausgewählte Kontaktperson</p>
                                <IoIosContact className="text-energo" size={120} />
                                {contactPerson !== null && contactPerson !== undefined ?
                                    <>
                                        <p className="mt-3"><b>{contactPerson.name}</b></p>
                                        <p className="text-muted">{contactPerson.email}</p>
                                    </>
                                :null}
                                <Button
                                    variant="warning"
                                    style={{ marginRight: 30, marginTop: 50, width: 300 }}
                                    onClick={() => setStage("contact")}
                                >
                                    Kontaktperson wählen
                                </Button>
                                <Button
                                    variant="energo"
                                    style={{ width: 300, marginTop: 50 }}
                                    onClick={() => setShow(false)}
                                >
                                    Weiter mit ausgewähltem Kontakt
                                </Button>
                            </Col>
                        </Row>
                        : null}
            </Modal.Body>
        </Modal>
    )
}
export default ContactPersonModal;